import { imprintBaseUrl, imprintUrls } from '../shared/constants/imprint.constants';

export const getProviderIconClass = (provider: string): string => {
    if (provider === null || provider === undefined) {
        return null;
    }
    switch (provider.toLowerCase()) {
        default:
            return 'eon-logo';
    }
};

export const getProviderMenuName = (provider: string): string => {
    if (provider === null || provider === undefined) {
        return null;
    }

    switch (provider.toLowerCase()) {
        default:
            return 'Mein E.ON';
    }
};

export const getProviderImprintUrl = (provider: string): string => {
    switch (provider) {
        case 'enviam':
            return imprintBaseUrl + imprintUrls.enviam;
        case 'eprimo':
            return imprintBaseUrl + imprintUrls.eprimo;
        case 'energis':
            return imprintBaseUrl + imprintUrls.energis;
        case 'lew':
            return imprintBaseUrl + imprintUrls.lew;
        case 'innogy':
        case 'mme@wmsb':
        case 'e.on-legacy':
        case 'e.on legacy':
        case 'e.on-da':
        case 'e.on da':
        case 'opto':
        case 'e.on':
            return imprintBaseUrl + imprintUrls.esc;
        case 'avacon':
            return imprintBaseUrl + imprintUrls.avacon;
        case 'schleswig-holstein netz':
            return imprintBaseUrl + imprintUrls.sh;
        case 'bayernwerk netz':
            return imprintBaseUrl + imprintUrls.bh;
        case 'edis':
        case 'e.dis':
            return imprintBaseUrl + imprintUrls.edis;
        default:
            return imprintBaseUrl + imprintUrls.esc;
    }
};
